/** Every URL on the site is built here, so links, sitemaps, emails and schema never disagree. */
export const SITE_HOST = 'nativesmokesuperstore.ca';
export const SITE_URL = `https://${SITE_HOST}`;
export const ADMIN_URL = `https://admin.${SITE_HOST}`;
/** Every API request from the storefront and the admin goes here. */
export const API_URL = `https://api.${SITE_HOST}`;
/** Origins allowed to call the API from a browser. */
export const API_ALLOWED_ORIGINS = [SITE_URL, `https://www.${SITE_HOST}`, ADMIN_URL, 'http://localhost:4321', 'http://localhost:5173'];

export const paths = {
  home: () => '/',
  shop: () => '/native-smokes/',
  product: (slug: string) => `/product/${slug}/`,
  brands: () => '/brands/',
  brand: (brandSlug: string) => `/brands/${brandSlug}/`,
  locations: () => '/online-locations/',
  province: (provinceSlug: string, page = 1) =>
    page <= 1 ? `/online-locations/${provinceSlug}/` : `/online-locations/${provinceSlug}/page/${page}/`,
  provinceSales: (provinceSlug: string) => `/buy-native-cigarettes-${provinceSlug}/`,
  city: (provinceSlug: string, citySlug: string) => `/online-locations/${provinceSlug}/${citySlug}/`,
  history: () => '/history/',
  faq: () => '/faq/',
  contact: () => '/contact/',
  shippingPolicy: () => '/shipping/',
  returnPolicy: () => '/return-policy/',
  privacy: () => '/privacy-policy/',
  terms: () => '/terms/',
  cart: () => '/cart/',
  checkout: () => '/checkout/',
  order: (number: number, token: string) => `/order/?n=${number}&t=${token}`,
  etransferPassword: (number?: number) => (number ? `/etransfer-password/?order=${number}` : '/etransfer-password/'),
} as const;

export function absolute(path: string): string {
  return `${SITE_URL}${path}`;
}

/** "Canadian Classics Original - Carton" -> "canadian-classics-original-carton". */
export function slugify(text: string): string {
  return text
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** "Playfare's" -> "playfares": brand page slugs. */
export function brandSlug(brand: string): string {
  return slugify(brand.replace(/'/g, ''));
}

/** Product photos are stored at these widths as WebP: `${src}-${width}.webp`. */
export const IMAGE_WIDTHS = [400, 800, 1200] as const;

export function imageUrl(src: string, width: (typeof IMAGE_WIDTHS)[number]): string {
  return `${src}-${width}.webp`;
}

export function imageSrcset(src: string): string {
  return IMAGE_WIDTHS.map((w) => `${imageUrl(src, w)} ${w}w`).join(', ');
}
